import { useEffect, useState } from "react";
import PermissionGate from "../../layout/PermissionGate";
import DriverPricingSelect from "../../layout/DriverPricingSelect";
import axios from "axios";

const DriverPayout = ({ id, setAlertConfig, fetchDriverDetails, data }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [pricingModel, setPricingModel] = useState(null);
    const [error, setError] = useState("");

    const token = localStorage.getItem("token");

    const updatePricingModel = async () => {
        setError("");
        setIsLoading(true);

        try {
            const res = await axios.patch(
                `${process.env.REACT_APP_API_ENDPOINT}update-driver-pricing-model/${id}`,
                { driverPricingModel: pricingModel },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (res.data.code === 1) {
                setAlertConfig({
                    show: true,
                    message: res.data.message,
                    type: "success",
                });
                fetchDriverDetails();
            } else {
                setAlertConfig({
                    show: true,
                    message: res.data.message,
                    type: "danger",
                });
            }
        } catch (err) {
            console.error(err);
            setAlertConfig({
                show: true,
                message: "Something went wrong",
                type: "danger",
            });
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        setPricingModel(data?.driverPricingModel ?? null);
    }, [data?.driverPricingModel]);

    return (
        <PermissionGate required={`change_driver_custom_sharing`}>
            <div className="card py-10">
                <div className="d-block d-md-flex justify-content-between px-10">
                    <div className="fs-2 fw-thin">Custom Payout ---</div>
                    <div className="d-flex mb-0 justify-content-end gap-2 mt-2">
                        <div style={{ minWidth: "260px" }}>
                            <DriverPricingSelect
                                value={pricingModel}
                                onChange={(modelId) => {
                                    setPricingModel(modelId);
                                    setError("");
                                }}
                                inheritLabel="Use company / default"
                                label=""
                                error={error}
                            />
                        </div>
                        <button
                            onClick={updatePricingModel}
                            disabled={isLoading}
                            className="btn btn-primary text-nowrap d-flex align-items-center justify-content-center"
                            style={{ minWidth: "230px" }}
                        >
                            {isLoading && (
                                <span
                                    className="spinner-border spinner-border-sm me-2"
                                    role="status"
                                    aria-hidden="true"
                                ></span>
                            )}
                            Change Custom Payout
                        </button>
                    </div>
                </div>
            </div>
        </PermissionGate>
    );
};

export default DriverPayout;